import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Row,
  Col,
  DatePicker,
  Select,
  Divider,
    Checkbox,
        Typography ,

  Button,
} from "antd";
import {
  UserOutlined,
  EnvironmentOutlined,
  MailOutlined,
  FlagOutlined,
} from "@ant-design/icons";
import { State } from '../../../JSON/data'
import { useNavigate, useParams } from 'react-router-dom';
import { getWorkmanById } from "../../../services/selfOnboarding";
import dayjs from "dayjs";
import { useTranslation } from 'react-i18next'; // <-- Add this
import { US_STATES } from "../mapping";
import NameCard from '../../../../assets/nameCard.png'



const { Option } = Select;
const states = State;
  const { Title } = Typography;



const I9Form = ({ value = {}, onChange }) => {
  const [form] = Form.useForm();
    const [consentChecked, setConsentChecked] = useState(false);
    const { workmanId } = useParams();
      const [loading, setLoading] = React.useState(true);

    const [selectedVisa, setSelectedVisa] = useState("");
      const { t } = useTranslation();
    

  const handleCheckboxChange = (checkedValues) => {
    // Take the first selected value only (single input at a time)
    setSelectedVisa(checkedValues[0] || "");
  }
    
    

    React.useEffect(() => {
        if (workmanId) {
          getWorkmanById(workmanId)
              .then((res) => {
                // Fix: convert dob to dayjs object if it's a date string
                const i9Section = res.data?.data?.["jobDetails&I9Section1"] || {};
                if (i9Section.dob && typeof i9Section.dob === "string") {
                  const d = dayjs(i9Section.dob);
                  i9Section.dob = d.isValid() ? d : undefined;
                }
                form.setFieldsValue(i9Section);
                if (onChange) onChange(i9Section);
              })
            .finally(() => setLoading(false));
        }
      }, [workmanId, form, onChange]);
    

  useEffect(() => {
    if (value) form.setFieldsValue(value);
  }, [value, form]);

  // watch the citizenship status field
  const citizenshipStatus = Form.useWatch("citizenshipStatus", form);

  const onFinish = (values) => {
  };

    const handleValuesChange = (_, allValues) => {
        allValues.id=workmanId
    if (onChange) onChange(allValues);
  };


  
  return (
    <Form
      form={form}
      layout="vertical"
      initialValues={value}
      onValuesChange={handleValuesChange}
    >
      {/* Name Section */}
      <Row align="middle" gutter={16}>
        <Col>
          <UserOutlined style={{ fontSize: 18, color: "#1677ff" }} />
        </Col>
        <Col flex="auto">
                  {/* <h3>Name</h3> */}
                   <Title
            style={{
              margin: 0,
              // color: '#0E4A9F',
              fontWeight: 600,
              fontSize: 'calc(16px + 0.2vh)',
            }}
            level={5}
          >
            {t('onboarding.name')}
          </Title>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={6}>
         <Form.Item
                      label={<span >{t('onboarding.lastNameLabel')}</span>}
                      name="lastName"
                      rules={[
                        { required: true, message: t('onboarding.lastNameRequired') },
                        { min: 2, message: t('onboarding.lastNameMin') },
                        { pattern: /^[A-Za-z]+$/, message: t('onboarding.lastNamePattern') },
                      ]}
                    >
                      <Input
                        placeholder={t('onboarding.lastNamePlaceholder')}
                        className='input-container'
                      />
                    </Form.Item>
        </Col>
        <Col span={6}>
           <Form.Item
                        label={<span >{t('onboarding.firstNameLabel')}</span>}
                        name="firstName"
                        rules={[
                          { required: true, message: t('onboarding.firstNameRequired') },
                          { min: 2, message: t('onboarding.firstNameMin') },
                          { pattern: /^[A-Za-z]+$/, message: t('onboarding.firstNamePattern') },
                        ]}
                      >
                        <Input
                          placeholder={t('onboarding.firstNamePlaceholder')}
                          className='input-container'
                        />
                      </Form.Item>
        </Col>
        <Col span={6}>
        <Form.Item
                      label={<span >{t('onboarding.middleNameLabel')}</span>}
                      name="middleInitial"
                      rules={[
                        { min: 1, message: t('onboarding.middleNameMin') },
                        { pattern: /^[A-Za-z]+$/, message: t('onboarding.middleNamePattern') },
                      ]}
                    >
                      <Input
                        placeholder={t('onboarding.middleNamePlaceholder')}
                        className='input-container'
                      />
                    </Form.Item>
        </Col>
        <Col span={6}>
           <Form.Item
                        label={<span >{t('onboarding.otherLastNamesLabel')}</span>}
                        name="otherLastNames"
                        rules={[
                          { min: 2, message: t('onboarding.otherLastNamesMin') },
                          { pattern: /^[A-Za-z]+$/, message: t('onboarding.otherLastNamesPattern') },
                        ]}
                      >
                        <Input
                          placeholder={t('onboarding.otherLastNamesPlaceholder')}
                          className='input-container'
                        />
                      </Form.Item>
        </Col>
      </Row>
      <Divider />

      {/* Location Section */}
      <Row align="middle" gutter={16}>
        <Col>
          <EnvironmentOutlined style={{ fontSize: 18, color: "#1677ff" }} />
        </Col>
        <Col flex="auto">
                  {/* <h3>Location</h3> */}
                  <Title
            style={{
              margin: 0,
              // color: '#0E4A9F',
              fontWeight: 600,
              fontSize: 'calc(16px + 0.2vh)',
            }}
            level={5}
          >
            {t('onboarding.location')}
          </Title>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={6}>
          <Form.Item
              label={<span >{t('onboarding.addressLabel')}</span>}
              name="address"
              rules={[
                { required: true, message: t('onboarding.addressRequired') },
                { min: 5, message: t('onboarding.addressMin') },
                { max: 100, message: t('onboarding.addressMax') },
              ]}
            >
              <Input
                placeholder={t('onboarding.addressPlaceholder')}
                className='input-container'
              />
            </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
              label={<span >{t('onboarding.cityLabel')}</span>}
              name="city"
              rules={[
                { required: true, message: t('onboarding.cityRequired') },
                { min: 2, message: t('onboarding.cityMin') },
                { max: 100, message: t('onboarding.cityMax') },
              ]}
            >
              <Input
                placeholder={t('onboarding.cityPlaceholder')}
                className='input-container'
              />
            </Form.Item>
        </Col>
       {/* <Col className='gutter-row' xs={24} sm={12} md={6} >
                       <Form.Item
                         name='state'
                         label='State'
                         rules={[{ required: true, message: 'Enter State' }]}
                         onChange={onChange}>
                         <Select
                           data-testid='pstate-select'
                           showSearch
                           filterOption={(input, option) =>
                             option.children
                               .toLowerCase()
                               .indexOf(input.toLowerCase()) >= 0
                           }
                           placeholder='Select State'
                           >
                           {states.map((state, index) => (
                             <Select.Option
                               key={`state-${index}`}
                               value={state.slice(0, 20)}
                               data-testid={`pstate-option-${state
                                 .replace(/\s+/g, '-')
                                 .toLowerCase()}`}>
                               {state}
                             </Select.Option>
                           ))}
                         </Select>
                       </Form.Item>
                     </Col> */}
               <Col span={6}>
           <Form.Item
                        label={<span >{t('onboarding.stateLabel')}</span>}
                        name="state"
                        rules={[
                          { required: true, message: 'Please enter your state' },
                          // { min: 2, message: 'State must be at least 2 characters' },
                          // { max: 100, message: 'State cannot exceed 50 characters' },
                        ]}
                      >
                        <Select
                          showSearch
                          placeholder={t('onboarding.statePlaceholder')}
                          className='input-container'
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                          }
                        >
                          {US_STATES.map(state => (
                            <Option key={state} value={state}>{state}</Option>
                          ))}
                        </Select>
                      </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={6}>
           <Form.Item
              label={<span >{t('onboarding.zipCodeLabel')}</span>}
              name="zipCode"
              rules={[
                { required: true, message: t('onboarding.zipCodeRequired') },
                { min: 5, message: t('onboarding.zipCodeMin') },
                { max: 10, message: t('onboarding.zipCodeMax') },
                { pattern: /^[0-9-]+$/, message: t('onboarding.zipCodePattern') },
              ]}
            >
              <Input
                placeholder={t('onboarding.zipCodePlaceholder')}
                className='input-container'
              />
            </Form.Item>
        </Col>
        <Col span={6}>
           <Form.Item
              label={<span >{t('onboarding.apartNumberLabel')}</span>}
              name="apartNumber"
              rules={[
                { min: 1, message: t('onboarding.apartNumberMin') },
                { max: 10, message: t('onboarding.apartNumberMax') },
              ]}
            >
              <Input
                placeholder={t('onboarding.apartNumberPlaceholder')}
                className='input-container'
              />
            </Form.Item>
        </Col>
      </Row>
      <Divider />

      {/* Contact Section */}
      <Row align="middle" gutter={16}>
        <Col>
          <MailOutlined style={{ fontSize: 18, color: "#1677ff" }} />
        </Col>
        <Col flex="auto">
                  {/* <h3>Contact other details</h3> */}
                  <Title
            style={{
              margin: 0,
              // color: '#0E4A9F',
              fontWeight: 600,
              fontSize: 'calc(16px + 0.2vh)',
            }}
            level={5}
          >
            {t('onboarding.personalDetails')}
          </Title>
          
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={6}>
        <Form.Item
              label={<span >{t('onboarding.emailLabel')}</span>}
              name="email"
              rules={[
                // { required: true, message: t('onboarding.emailRequired') },
                { type: 'email', message: t('onboarding.emailPattern') },
              ]}
            >
              <Input
                placeholder={t('onboarding.emailPlaceholder')}
                className='input-container'
              />
            </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
              label={<span >{t('onboarding.mobileLabel')}</span>}
              name="mobile"
              rules={[
                // { required: true, message: 'Please enter your mobile number' },
                {
                  pattern: /^\d{3}-\d{3}-\d{4}$/, // validate formatted XXX-XXX-XXXX
                  message: t('onboarding.mobilePattern'),
                },
              ]}
              getValueFromEvent={(e) => {
                // Always store formatted value in form state
                const digits = e.target.value.replace(/\D/g, "").slice(0, 10);
                if (digits.length <= 3) return digits;
                if (digits.length <= 6) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
                return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
              }}
            >
              <Input
                maxLength={12} // 10 digits + 2 dashes
                className="input-container"
                placeholder={t('onboarding.mobilePlaceholder')}
                onChange={(e) => {
                  let digits = e.target.value.replace(/\D/g, "").slice(0, 10);
                  if (digits.length <= 3) e.target.value = digits;
                  else if (digits.length <= 6) e.target.value = `${digits.slice(0, 3)}-${digits.slice(3)}`;
                  else e.target.value = `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
                }}
                // value={formatted}
              />
            </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
                       label={<span >{t('onboarding.dobLabel')}</span>}
                       name="dob"
                       rules={[
                         { required: true, message: t('onboarding.dobRequired') },
                         ({ getFieldValue }) => ({
                           validator(_, value) {
                             if (!value) {
                               return Promise.resolve();
                             }
                             const today = dayjs();
                             const age = today.diff(value, 'year');
                             if (age >= 18) {
                               return Promise.resolve();
                             }
                             return Promise.reject(new Error(t('onboarding.dobMin')));
                           },
                         }),
                       ]}
                     >
                       <DatePicker
                         format="YYYY-MM-DD"
                         placeholder={t('onboarding.dobPlaceholder')}
                          //  className='input-container'
                                              style={{ width: '100%',  }}

                          
                       />
                     </Form.Item>
        </Col>
        <Col span={6}>
       <Form.Item
    name="ssnNumber"
    label={t('onboarding.ssn')}
    rules={[
      { required: true, message: t('onboarding.ssnError') },
      {
        pattern: /^\d{3}-\d{2}-\d{4}$/,
        message:  "Format must be 999-99-9999"
      }
    ]}
    getValueFromEvent={e => {
      // Format as XXX-XX-XXXX
      const digits = e.target.value.replace(/\D/g, "").slice(0, 9);
      if (digits.length <= 3) return digits;
      if (digits.length <= 5) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
      return `${digits.slice(0, 3)}-${digits.slice(3, 5)}-${digits.slice(5, 9)}`;
    }}
  >
    <Input
      maxLength={11}
      placeholder="XXX-XX-XXXX"
      className="input-container"
    />
  </Form.Item>



        </Col>
      </Row>
      <Divider />

      {/* Citizenship Section */}
      <Row align="middle" gutter={16}>
        <Col>
          <FlagOutlined style={{ fontSize: 18, color: "#1677ff" }} />
        </Col>
        <Col flex="auto">
          <Title
            style={{
              margin: 0,
              // color: '#0E4A9F',
              fontWeight: 600,
              fontSize: 'calc(16px + 0.2vh)',
            }}
            level={5}
          >
            {t('onboarding.citizenshipInfo')}
          </Title>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name="citizenshipStatus"
            label={t('onboarding.citizenshipStatusLabel')}
            rules={[{ required: true, message: t('onboarding.citizenshipStatusRequired') }]
}
          >
            <Select placeholder={t('onboarding.citizenshipStatusPlaceholder')}>
              <Option value="unitedState">{t('onboarding.citizenUS')}</Option>
              <Option value="presidentResident">{t('onboarding.lawfulPermanentResident')}</Option>
              <Option value="ead">{t('onboarding.alienAuthorizedEAD')}</Option>
              <Option value="temporaryVisa">{t('onboarding.alienAuthorizedTempVisa')}</Option>
            </Select>
          </Form.Item>
        </Col>
      </Row>

      {/* Conditional Rendering */}
      {citizenshipStatus === "ead" && (
        <Row gutter={16}>
          <Col span={4}>
            <Form.Item
              name="eadNumber"
              label="USCIS A-Number"
              rules={[{ required: true, message: "Please enter your USCIS A-Number" }]}
            >
              <Input placeholder="Enter USCIS A-Number" />
            </Form.Item>
                  </Col>
                  <Col span={4}>
          <Form.Item
            name="expirationDate"
            label="Expiration Date"
            rules={[{ required: true, message: "Required" }]}
          >
            <DatePicker format="DD-MM-YYYY" style={{ width: "100%" }} />
          </Form.Item>
        </Col>
        </Row>
      )}

      {citizenshipStatus === "temporaryVisa" && (
        <>
          <Row gutter={16}>
            <Col span={4}>
              <Form.Item
                name="visaType"
                label="Select and enter the relevant number"
                rules={[{ required: true, message: "Please select at least one visa type" }]}
              >
                <Checkbox.Group
                  style={{ display: "flex", flexDirection: "column" }}
                  onChange={handleCheckboxChange}
                >
                  <Checkbox value="uscis">USCIS A-Number</Checkbox>
                  <Checkbox value="i94Number">I-94 Number</Checkbox>
                  <Checkbox value="foreignPassport">Foreign Passport Number & Country of Issue</Checkbox>
                </Checkbox.Group>
              </Form.Item>
            </Col>
          </Row>

          {selectedVisa === "uscis" && (
            <Row gutter={16}>
              <Col span={4}>
                <Form.Item
                  name="uscisANumber"
                  label="USCIS A-Number"
                  rules={[{ required: true, message: "Please enter your USCIS A-Number" }]}
                >
                  <Input placeholder="Enter USCIS A-Number" />
                </Form.Item>
              </Col>
            </Row>
          )}

          {selectedVisa === "i94Number" && (
            <Row gutter={16}>
              <Col span={4}>
                <Form.Item
                  name="i94Date"
                  label="I-94 Date"
                  rules={[{ required: true, message: "Please select the I-94 date" }]}
                >
                  <DatePicker style={{ width: "100%" }} />
                </Form.Item>
              </Col>
            </Row>
          )}

          {selectedVisa === "foreignPassport" && (
            <Row gutter={16}>
              <Col span={4}>
                <Form.Item
                  name="passportNumber"
                  label="Foreign Passport Number"
                  rules={[{ required: true, message: "Please enter your passport number" }]}
                >
                  <Input placeholder="Enter Passport Number" />
                </Form.Item>
              </Col>
              <Col span={4}>
                <Form.Item
                  name="countryIssueDate"
                  label="Country of Issue Date"
                  rules={[{ required: true, message: "Please select the date of issue" }]}
                >
                  <DatePicker style={{ width: "100%" }} />
                </Form.Item>
              </Col>
            </Row>
          )}
        </>
      )}

      <Divider />

      {/* Consent Section */}
      <Row>
        <Col span={24} hidden={workmanId}>
          <Checkbox
            checked={consentChecked}
                      onChange={(e) => setConsentChecked(e.target.checked)}
          >
                  {t('onboarding.citizenshipConsentText')}
                  </Checkbox>
        </Col>
      </Row>

      
    </Form>
  );
};

export default I9Form;
